/* ============================================================================
   NEXT Hub — Global cart + side drawer (mockup of the Shopify cart experience).
   PORTS TO SHOPIFY: maps to sections/cart-drawer.liquid + the AJAX Cart API
   (/cart/add.js, /cart/change.js, /cart.js). Here we simulate it with
   localStorage so "Add to Cart" works across the demo and survives page nav.
   Auto-injected by nexthub-chrome.js, so every page gets the cart.

   Public API (used by PDPs / product cards):
     NHcart.add({ id, title, price, img, qty })   // qty optional (default 1)
     NHcart.open() / NHcart.close()
     NHcart.setQty(id, n) / NHcart.remove(id)

   Free-mic mechanic: whenever the NEXT Hub (id 'hub') is in the cart, a matching
   quantity of the 3-in-1 Mic is auto-added at $0 and labelled "Free with NEXT Hub".
   On Shopify this is the GWP-app / bundle job (BUNDLE_DISCOUNT_DECISION.md);
   here we model the customer-facing result.
   ============================================================================ */
(function () {
  function NHA(f){ return (window.NEXTHUB_ASSETS && window.NEXTHUB_ASSETS[f]) || ('assets/img/' + f); }
  var KEY = "nh_cart_v1";
  var FREE_SHIP_QTY = 5;              // free shipping at 5+ Hubs
  var MIC = { id: "mic", title: "NEXT 3-in-1 Microphone System", price: 0, img: "https://store.next-hub.com/cdn/shop/files/CT24_NEXTHub_Logo_Horizontal-Color.png?v=1767091960", free: true, note: "Free with every NEXT Hub" };
  // FOBio complementary product (cart cross-sell). PORT: settings.cart_recommendations /
  // Search & Discovery complementary product on sections/cart-drawer.liquid.
  var FOBIO = { id: "fobio", title: "NEXT FOBio - Pack of 6", price: 89.99, img: NHA("fobio-fob.png"), qty: 1 };

  // Inline SVGs for the trust row (no emoji, no deps). 16x16, currentColor stroke.
  var ICON = {
    mic: '<svg class="nh-trust-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"></rect><path d="M5 10a7 7 0 0 0 14 0"></path><line x1="12" y1="17" x2="12" y2="22"></line><line x1="8" y1="22" x2="16" y2="22"></line></svg>',
    ship: '<svg class="nh-trust-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="6" width="13" height="11" rx="1"></rect><path d="M14 9h4l3 3v5h-7z"></path><circle cx="6" cy="19" r="2"></circle><circle cx="18" cy="19" r="2"></circle></svg>',
    returns: '<svg class="nh-trust-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>',
    lock: '<svg class="nh-trust-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>'
  };

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(c) { localStorage.setItem(KEY, JSON.stringify(c)); }
  function fmt(v) { return v === 0 ? "FREE" : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 }).format(v); }

  var cart = load();

  function syncFreeMic() {
    var hub = cart.filter(function (i) { return i.id === "hub"; })[0];
    cart = cart.filter(function (i) { return i.id !== "mic"; });
    if (hub) {
      var m = Object.assign({}, MIC, { qty: hub.qty });
      cart.push(m);
    }
  }
  function subtotal() { return cart.reduce(function (s, i) { return s + i.price * i.qty; }, 0); }
  function unitCount() { return cart.reduce(function (s, i) { return s + (i.free ? 0 : i.qty); }, 0); }
  function hubCount() { var h = cart.filter(function (i) { return i.id === "hub"; })[0]; return h ? h.qty : 0; }

  function injectDrawer() {
    if (document.getElementById("nh-cart-drawer")) return;
    var el = document.createElement("div");
    el.innerHTML =
      '<div class="nh-cart-overlay" id="nh-cart-overlay"></div>' +
      '<aside class="nh-cart-drawer" id="nh-cart-drawer" aria-hidden="true" aria-label="Cart">' +
        '<div class="nh-cart-head"><h3>Your cart</h3><button class="nh-cart-x" aria-label="Close">×</button></div>' +
        '<div class="nh-ship-bar"><div class="nh-ship-msg" id="nh-ship-msg"></div><div class="nh-ship-track"><div class="nh-ship-fill" id="nh-ship-fill"></div></div></div>' +
        '<div class="nh-cart-items" id="nh-cart-items"></div>' +
        // PORT: cross-sell powered by settings.cart_recommendations / Search & Discovery
        // complementary products on sections/cart-drawer.liquid (no localStorage on live).
        '<div class="nh-upsell" id="nh-upsell" hidden></div>' +
        '<div class="nh-cart-foot">' +
          '<div class="nh-cart-subtotal"><span>Subtotal</span><b id="nh-cart-subtotal">$0</b></div>' +
          '<p class="nh-cart-fine">Shipping &amp; taxes calculated at checkout. Free $499 mic auto-added with every NEXT Hub.</p>' +
          // PORT: trust row → sections/cart-drawer.liquid footer (replaces review highlights;
          // no reviews yet). Link hrefs map to shop.shipping_policy.url / shop.refund_policy.url.
          '<div class="nh-trust-row">' +
            '<div class="nh-trust-item">' + ICON.mic + '<span>Free $499 mic included</span></div>' +
            '<div class="nh-trust-item">' + ICON.ship + '<span>Free shipping on 5+ Hubs</span></div>' +
            // PORT: href → shop.shipping_policy.url / shop.refund_policy.url
            '<a class="nh-trust-item" href="#">' + ICON.returns + '<span>Shipping &amp; returns</span></a>' +
            '<div class="nh-trust-item">' + ICON.lock + '<span>Secure checkout</span></div>' +
          '</div>' +
          '<a href="#" class="btn btn-primary nh-checkout" id="nh-checkout">Checkout</a>' +
          '<button class="nh-cart-cont">Continue shopping</button>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(el);
    document.getElementById("nh-cart-overlay").addEventListener("click", close);
    el.querySelector(".nh-cart-x").addEventListener("click", close);
    el.querySelector(".nh-cart-cont").addEventListener("click", close);
    document.getElementById("nh-checkout").addEventListener("click", function (e) {
      e.preventDefault();
      // PORT: real Shopify checkout → window.location = '/checkout'
      alert("Demo: this routes to Shopify checkout (/checkout) on the live store.");
    });
  }

  function render() {
    var itemsEl = document.getElementById("nh-cart-items");
    if (!itemsEl) return;
    if (!cart.length) {
      itemsEl.innerHTML = '<div class="nh-cart-empty"><p>Your cart is empty.</p><a href="/products/next-hub-display-upgrade-solution" class="btn btn-secondary">Shop the NEXT Hub</a></div>';
    } else {
      itemsEl.innerHTML = cart.map(function (i) {
        return '<div class="nh-line' + (i.free ? " is-free" : "") + '">' +
          '<img src="' + i.img + '" alt="" />' +
          '<div class="nh-line-main">' +
            '<div class="nh-line-title">' + i.title + (i.note ? ' <span class="nh-free-tag">' + i.note + '</span>' : '') + '</div>' +
            '<div class="nh-line-price">' + fmt(i.price) + (i.price ? ' <span class="nh-line-each">each</span>' : '') + '</div>' +
            (i.free
              ? '<div class="nh-line-qty-static">Qty ' + i.qty + ' · matches your Hubs</div>'
              : '<div class="nh-qty"><button data-act="dec" data-id="' + i.id + '">–</button><span>' + i.qty + '</span><button data-act="inc" data-id="' + i.id + '">+</button>' +
                '<button class="nh-line-remove" data-act="rm" data-id="' + i.id + '">Remove</button></div>') +
          '</div>' +
          '<div class="nh-line-sum">' + fmt(i.price * i.qty) + '</div>' +
        '</div>';
      }).join("");
      itemsEl.querySelectorAll("[data-act]").forEach(function (b) {
        b.addEventListener("click", function () {
          var id = this.getAttribute("data-id"), act = this.getAttribute("data-act");
          var it = cart.filter(function (x) { return x.id === id; })[0];
          if (!it) return;
          if (act === "inc") setQty(id, it.qty + 1);
          else if (act === "dec") setQty(id, it.qty - 1);
          else if (act === "rm") remove(id);
        });
      });
    }
    document.getElementById("nh-cart-subtotal").textContent = fmt(subtotal());

    // free-shipping progress (based on Hub qty)
    var hc = hubCount(), msg = document.getElementById("nh-ship-msg"), fill = document.getElementById("nh-ship-fill");
    var pctv = Math.min(100, Math.round(hc / FREE_SHIP_QTY * 100));
    fill.style.width = pctv + "%";
    if (hc >= FREE_SHIP_QTY) msg.innerHTML = "You've unlocked <b>free shipping</b>!";
    else if (hc > 0) msg.innerHTML = "Add <b>" + (FREE_SHIP_QTY - hc) + " more Hub" + (FREE_SHIP_QTY - hc > 1 ? "s" : "") + "</b> for free shipping.";
    else msg.innerHTML = "Free shipping on orders of " + FREE_SHIP_QTY + "+ Hubs.";

    renderUpsell();
    updateCount();
  }

  // FOBio cross-sell: show only when a NEXT Hub is in the cart and FOBio is not.
  // PORT: settings.cart_recommendations / Search & Discovery complementary product.
  function renderUpsell() {
    var box = document.getElementById("nh-upsell");
    if (!box) return;
    var hasHub = cart.some(function (i) { return i.id === "hub"; });
    var hasFobio = cart.some(function (i) { return i.id === "fobio"; });
    if (!hasHub || hasFobio) { box.hidden = true; box.innerHTML = ""; return; }
    box.hidden = false;
    box.innerHTML =
      '<img class="nh-upsell-thumb" src="' + FOBIO.img + '" alt="" />' +
      '<div class="nh-upsell-info">' +
        '<div class="nh-upsell-title">' + FOBIO.title + '</div>' +
        '<div class="nh-upsell-price">$89.99 / pack of 6 · tap-to-login</div>' +
      '</div>' +
      '<button class="nh-upsell-add" type="button">Add</button>';
    box.querySelector(".nh-upsell-add").addEventListener("click", function () {
      add({ id: "fobio", title: "NEXT FOBio - Pack of 6", price: 89.99, img: FOBIO.img, qty: 1 });
    });
  }

  function updateCount() {
    var n = unitCount();
    document.querySelectorAll(".nh-cart-count").forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? "grid" : "none";
    });
  }

  function open() { injectDrawer(); render(); document.getElementById("nh-cart-drawer").classList.add("open"); document.getElementById("nh-cart-overlay").classList.add("show"); document.getElementById("nh-cart-drawer").setAttribute("aria-hidden", "false"); }
  function close() { var d = document.getElementById("nh-cart-drawer"); if (!d) return; d.classList.remove("open"); document.getElementById("nh-cart-overlay").classList.remove("show"); d.setAttribute("aria-hidden", "true"); }

  function add(item) {
    var existing = cart.filter(function (i) { return i.id === item.id; })[0];
    if (existing) existing.qty += (item.qty || 1);
    else cart.push({ id: item.id, title: item.title, price: item.price, img: item.img, qty: item.qty || 1 });
    syncFreeMic(); save(cart); open();
  }
  function setQty(id, n) {
    var it = cart.filter(function (i) { return i.id === id; })[0];
    if (!it) return;
    if (n <= 0) return remove(id);
    it.qty = n; syncFreeMic(); save(cart); render();
  }
  function remove(id) { cart = cart.filter(function (i) { return i.id !== id; }); syncFreeMic(); save(cart); render(); }

  // init
  syncFreeMic(); save(cart);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { injectDrawer(); updateCount(); });
  else { injectDrawer(); updateCount(); }

  window.NHcart = { add: add, open: open, close: close, setQty: setQty, remove: remove };
})();
